'use es6';

import { createAction } from 'flux-actions';
import * as ActionTypes from '../constants/VisitorActionTypes';
import { getSelectedThreadId } from '../selected-thread/selectors/getSelectedThreadId';
export const setMessageEditorTextAction = createAction(ActionTypes.UPDATE_MESSAGE_EDITOR_STAGING_TEXT, stagingText => stagingText);
export const removeMessageEditorStagingTextAction = createAction(ActionTypes.REMOVE_MESSAGE_EDITOR_STAGING_TEXT, selectedThreadId => selectedThreadId);
export const setMessageEditorStagingText = stagingText => {
  return (dispatch, getState) => {
    dispatch(setMessageEditorTextAction({
      stagingText,
      threadId: getSelectedThreadId(getState())
    }));
  };
};
export const removeMessageEditorStagingText = () => {
  return (dispatch, getState) => {
    dispatch(removeMessageEditorStagingTextAction(getSelectedThreadId(getState())));
  };
};